import React from 'react';

/**
 * Renderiza el bloque CauseWorkspace de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function CauseWorkspace({
  v
}) {
  return React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "13.020833vw minmax(0,1fr) 18.75vw",
      "gap": "1.111111vh",
      "minHeight": "0"
    }
  }, v.text("\n      "), React.createElement("aside", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "minHeight": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh",
      "paddingBottom": "0.37037vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.296296vh",
      "fontWeight": "600"
    }
  }, v.text("Qué la explica")), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, v.text("veces más PPA en la condición más desfavorable"))), v.text("\n        "), (v.czDrivers || []).map((d, index83) => React.createElement(React.Fragment, {
    key: index83
  }, React.createElement("button", {
    "onClick": d.onClick,
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.462963vh",
      "padding": "0.833333vh 0.925926vh",
      "borderRadius": "0.648148vh",
      "border": "0.092593vh solid " + d.bd,
      "background": d.bg,
      "cursor": "pointer",
      "textAlign": "left",
      "color": "#e4e9f0"
    },
    className: "scapp-full-hover"
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline",
      "gap": "0.740741vh",
      "width": "100%"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.203704vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text(d.l)), React.createElement("span", {
    style: {
      "font": "600 1.388889vh 'IBM Plex Mono',monospace",
      "color": d.c
    }
  }, v.text(d.lift))), React.createElement("div", {
    style: {
      "height": "0.462963vh",
      "width": "100%",
      "borderRadius": "0.277778vh",
      "background": "#1c2636",
      "display": "flex"
    }
  }, React.createElement("div", {
    style: {
      "width": d.w,
      "minWidth": "0.15625vw",
      "background": d.c,
      "borderRadius": "0.277778vh"
    }
  }, null)), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, v.text(d.sub))))), v.text("\n      ")), v.text("\n      "), React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.296296vh 1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "minHeight": "0",
      "minWidth": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.111111vh",
      "flexWrap": "wrap"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.388889vh",
      "fontWeight": "600"
    }
  }, v.text(v.czTitle)), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.555556vh 1.296296vh",
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "flexWrap": "wrap",
      "alignItems": "center"
    }
  }, v.czNoSplit ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "height": "0.231481vh",
      "background": "oklch(0.72 0.16 350)"
    }
  }, null), v.text("PPA promedio del tramo"))) : null, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "rgba(46,179,238,0.3)"
    }
  }, null), v.text("% del tiempo en el tramo (eje der.)")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "borderTop": "0.092593vh dashed rgba(228,233,240,0.6)"
    }
  }, null), v.text("promedio general")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "height": "1.111111vh",
      "borderLeft": "0.104167vw dashed oklch(0.7 0.18 28)"
    }
  }, null), v.text("umbral de la regla")), v.czNoSplit ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.416667vw",
      "height": "0.740741vh",
      "borderRadius": "50%",
      "background": "oklch(0.8 0.15 75)"
    }
  }, null), v.text("≥ 1,4×")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.416667vw",
      "height": "0.740741vh",
      "borderRadius": "50%",
      "background": "oklch(0.7 0.18 28)"
    }
  }, null), v.text("≥ 2× el promedio"))) : null, (v.czLeg || []).map((g, index84) => React.createElement(React.Fragment, {
    key: index84
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "height": "0.185185vh",
      "background": g.c
    }
  }, null), v.text(g.l))))), v.czSplitCan ? React.createElement(React.Fragment, null, React.createElement("button", {
    "onClick": v.czSplitTog,
    style: {
      "marginLeft": "auto",
      "background": "transparent",
      "border": "0.092593vh solid rgba(46,179,238,0.25)",
      "color": "#b8c1ce",
      "borderRadius": "0.555556vh",
      "padding": "0.277778vh 0.925926vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.czSplitL))) : null), v.text("\n        "), React.createElement("div", {
    "onMouseLeave": v.czLeave,
    style: {
      "flex": "1",
      "minHeight": "0",
      "position": "relative",
      "margin": "2.222222vh 4.444444vh 3.703704vh 4.814815vh"
    }
  }, v.text("\n          "), React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "-2.708333vw",
      "top": "-2.037037vh",
      "fontSize": "1.018519vh",
      "color": "oklch(0.78 0.12 350)",
      "whiteSpace": "nowrap"
    }
  }, v.text("↑ " + v.czYTitle)), v.text("\n          "), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "-2.5vw",
      "top": "-2.037037vh",
      "fontSize": "1.018519vh",
      "color": "rgba(110,190,240,0.9)",
      "whiteSpace": "nowrap"
    }
  }, v.text("% tiempo ↑")), v.text("\n          "), (v.czTR || []).map((y, index85) => React.createElement(React.Fragment, {
    key: index85
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "calc(100% + 0.3125vw)",
      "top": y.top,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "rgba(110,190,240,0.9)",
      "whiteSpace": "nowrap"
    }
  }, v.text(y.lab)))), v.text("\n          "), React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "50%",
      "top": "calc(100% + 2.037037vh)",
      "transform": "translateX(-50%)",
      "fontSize": "1.111111vh",
      "fontWeight": "600",
      "color": "#b8c1ce",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.czXTitle + " →")), v.text("\n          "), (v.czYt || []).map((y, index86) => React.createElement(React.Fragment, {
    key: index86
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": y.top,
      "borderTop": "0.092593vh solid rgba(135,147,166,0.12)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "calc(100% + 0.3125vw)",
      "top": y.top,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.78 0.12 350)"
    }
  }, v.text(y.lab)))), v.text("\n          "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": v.czMeanT,
      "borderTop": "0.092593vh dashed rgba(228,233,240,0.35)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "left": "0.208333vw",
      "top": v.czMeanT,
      "transform": "translateY(-110%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, v.text(v.czMeanL)), v.text("\n          "), React.createElement("svg", {
    "viewBox": "0 0 600 100",
    "preserveAspectRatio": "none",
    style: {
      "position": "absolute",
      "inset": "0",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "overflow": "visible"
    }
  }, React.createElement("path", {
    "d": v.czTime,
    "fill": "rgba(46,179,238,0.22)"
  }, null), (v.czLines || []).map((l, index87) => React.createElement(React.Fragment, {
    key: index87
  }, React.createElement("path", {
    "d": l.d,
    "stroke": l.c,
    "strokeWidth": l.w,
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeLinejoin": "round"
  }, null)))), v.text("\n          "), (v.czDots || []).map((d, index88) => React.createElement(React.Fragment, {
    key: index88
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": d.x,
      "top": d.y,
      "width": "0.46875vw",
      "height": "0.833333vh",
      "margin": "-0.416667vh 0 0 -0.416667vh",
      "borderRadius": "50%",
      "background": d.c,
      "border": "0.185185vh solid #0a1424",
      "pointerEvents": "none"
    }
  }, null))), v.text("\n          "), v.czThrOn ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "-0.37037vh",
      "bottom": "0",
      "left": v.czThrL,
      "borderLeft": "0.104167vw dashed oklch(0.7 0.18 28)",
      "pointerEvents": "none"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "top": "0",
      "left": v.czThrL,
      "transform": v.czThrTx,
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.78 0.15 30)",
      "background": "rgba(6,14,28,0.85)",
      "padding": "0.185185vh 0.555556vh",
      "borderRadius": "0.37037vh",
      "whiteSpace": "nowrap",
      "pointerEvents": "none"
    }
  }, v.text(v.czThrT))) : null, v.text("\n          "), v.czTip.on ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "2.592593vh",
      "left": v.czTip.L,
      "transform": v.czTip.tx,
      "zIndex": "10",
      "width": "11.979167vw",
      "background": "rgba(6,14,28,0.96)",
      "border": "0.092593vh solid rgba(46,179,238,0.35)",
      "borderRadius": "0.740741vh",
      "padding": "0.833333vh 1.018519vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "pointerEvents": "none",
      "boxShadow": "0 0.925926vh 2.407407vh rgba(0,0,0,0.5)"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "paddingBottom": "0.277778vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.14)"
    }
  }, v.text(v.czTip.title)), (v.czTip.rows || []).map((x, index89) => React.createElement(React.Fragment, {
    key: index89
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.740741vh",
      "fontSize": "1.111111vh"
    }
  }, React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.v))))))) : null, v.text("\n          "), React.createElement("div", {
    style: {
      "position": "absolute",
      "inset": "0",
      "display": "flex",
      "zIndex": "4"
    }
  }, (v.czHits || []).map((h, index90) => React.createElement(React.Fragment, {
    key: index90
  }, React.createElement("div", {
    "onMouseEnter": h.enter,
    style: {
      "flex": "1",
      "minWidth": "0",
      "cursor": "crosshair"
    }
  }, null)))), v.text("\n          "), (v.czX || []).map((x, index91) => React.createElement(React.Fragment, {
    key: index91
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.462963vh)",
      "left": x.left,
      "transform": "translateX(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.lab)))), v.text("\n          \n        ")), v.text("\n      ")), v.text("\n      "), React.createElement("aside", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "minHeight": "0",
      "minWidth": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.296296vh",
      "fontWeight": "600"
    }
  }, v.text("Combinaciones · " + v.czGT)), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0.37037vh"
    }
  }, (v.czV2 || []).map((m, index92) => React.createElement(React.Fragment, {
    key: index92
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0.092593vh solid rgba(46,179,238,0.18)",
      "borderRadius": "1.111111vh",
      "padding": "0.185185vh 0.833333vh",
      "font": "1.018519vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color
    }
  }, v.text(m.l)))))), v.text("\n        "), React.createElement("div", {
    "onMouseLeave": v.czGLeave,
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, (v.czGrid || []).map((g, index93) => React.createElement(React.Fragment, {
    key: index93
  }, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": "2.291667vw repeat(" + v.czGridCols + ",minmax(0,1fr))",
      "gap": "0.185185vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "#8793a6",
      "alignSelf": "center",
      "whiteSpace": "nowrap"
    }
  }, v.text(g.lab)), (g.cells || []).map((c, index94) => React.createElement(React.Fragment, {
    key: index94
  }, React.createElement("div", {
    "onMouseEnter": c.enter,
    style: {
      "borderRadius": "0.185185vh",
      "background": c.bg,
      "outline": c.ol,
      "minHeight": "0.555556vh"
    }
  }, null)))))), v.text("\n          "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "2.291667vw repeat(" + v.czGridCols + ",minmax(0,1fr))",
      "gap": "0.185185vh",
      "paddingTop": "0.185185vh"
    }
  }, React.createElement("span", {}, null), (v.czGXL || []).map((x, index95) => React.createElement(React.Fragment, {
    key: index95
  }, React.createElement("span", {
    style: {
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.lab))))), v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "fontSize": "0.925926vh",
      "color": "#5a667a"
    }
  }, React.createElement("span", {}, v.text("↑ " + v.czGY)), React.createElement("span", {}, v.text(v.czGX + " →"))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.740741vh",
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "flexWrap": "wrap"
    }
  }, React.createElement("span", {
    style: {
      "whiteSpace": "nowrap"
    }
  }, v.text("Color = " + v.czGOut)), React.createElement("span", {
    style: {
      "font": "0.925926vh 'IBM Plex Mono',monospace"
    }
  }, v.text("0")), React.createElement("span", {
    style: {
      "width": "4.6875vw",
      "height": "0.740741vh",
      "borderRadius": "0.185185vh",
      "background": "linear-gradient(90deg,oklch(0.3 0.04 190),oklch(0.51 0.12 108),oklch(0.72 0.2 25))"
    }
  }, null), React.createElement("span", {
    style: {
      "font": "0.925926vh 'IBM Plex Mono',monospace"
    }
  }, v.text(v.czGMax)), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.37037vh",
      "whiteSpace": "nowrap",
      "marginLeft": "0.208333vw"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "repeating-linear-gradient(135deg,#3a4558 0 0.185185vh,transparent 0.185185vh 0.462963vh)"
    }
  }, null), v.text("pocos datos"))), v.text("\n        "), React.createElement("div", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#b8c1ce",
      "minHeight": "2.777778vh",
      "lineHeight": "1.4",
      "textWrap": "pretty"
    }
  }, v.text(v.czGInfo)), v.text("\n      ")), v.text("\n    "));
}
